import localization from './localization';

export default {
    mypage: '/mypage',
    spotlight: '/profile',

    findjobs: '/',
    jobDetail: '/job',
    findcompanies: '/companies',

    resources: '/resources',

    apps: '/apps',
    favorites: '/favorites',

    tests: '/tests',
    cute: 'cut-e',

    emailVerification: '/verify',
    recoverUser: '/recover',
    recoverPassword: '/recover-password',

    redirect: '/redirect',

    aboutGPTW: '/about-gptw',

    internalResources: '/resources/internal',

    calendar: '/calendar',
    book: '/book',

    activateUser: '/activate-user', // Might rename, imported user register flow.

    vfairsLegacy: '/vfairs',
    vfairLegacy: '/vfair',
    vfairsHomeLegacy: localization.isSchoolPlatform ? '/vfairs' : '/',

    vfairs: '/vevents',
    vfair: '/vevent',
    vfairsHome: localization.isSchoolPlatform ? '/vevents' : '/',
};
